import cheese from '../images/ingredients/cheese.png';
import pepper from '../images/ingredients/pepper.png';
import mushroom from '../images/ingredients/mushroom.png';
import olives from '../images/ingredients/olives.png';
import onion from '../images/ingredients/onion.png';

export const ingredients = [
    {
        id: 1,
        src: cheese,
        name: 'cheese',
        price: 500,
        weight: 100
    },
    {
        id: 2,
        src: pepper,
        name: 'pepper',
        price: 200,
        weight: 150
    },
    {
        id: 3,
        src: mushroom,
        name: 'mushroom',
        price: 750,
        weight: 500
    },
    {
        id: 4,
        src: onion,
        name: 'onion',
        price: 200,
        weight: 75
    },
    {
        id: 5,
        src: olives,
        name: 'olives',
        price: 100,
        weight: 40
    },
]
